import { carouselStyles as styles } from "@bevco/Overrides/Components/ProductCompareCarousel";
import { colorStrings, mediaQueriesBP } from "@bevco/Utilities/variables";
import { css } from "styled-components";

styles.prevArrowGridItem = {
    ...styles.prevArrowGridItem,
    align: "top",
};

styles.prevArrowButton = {
    ...styles.prevArrowButton,
    css: css`
        ${styles.prevArrowButton?.css}
        top: 350px;
        height: 380px;

        ${mediaQueriesBP.maxMD} {
            top: 180px;
        }
    `,
};

styles.nextArrowGridItem = {
    ...styles.nextArrowGridItem,
    align: "top",
};

styles.nextArrowButton = {
    ...styles.nextArrowButton,
    css: css`
        ${styles.nextArrowButton?.css}
        top: 350px;
        height: 380px;

        ${mediaQueriesBP.maxMD} {
            top: 180px;
        }
    `,
};
